// Zentrale Sponsorendaten je Stufe
// Hinweis: URLs/Logos können hier gepflegt und erweitert werden

export const mainSponsors = [
    // {
    //   name: "Sparkasse Barnim",
    //   url: "https://www.spk-barnim.de/",
    //   src: "images/sponsors/sparkasse.png",
    // },
    // {
    //   name: "Partner Example",
    //   url: "#",
    //   src: "images/placeholder.jpg",
    // },
  ];
  
  // Gold-Stufe (Platzhalter bis echte Logos vorliegen)
  export const goldSponsors = [
    { name: "Platz Gruppe", url: "https://www.platz-gruppe.de/", src: "images/sponsors/platz_gruppe.png" },
    { name: "Ergotherapie Weyrauch", url: "https://ergotherapie-weyrauch.de/", src: "images/sponsors/ergotherapie_weyrauch.png" },
    // { name: "QT", url: "#", src: "images/placeholder.jpg" },
    // { name: "RP", url: "#", src: "images/placeholder.jpg" },
    // { name: "BB", url: "#", src: "images/placeholder.jpg" },
    // { name: "SK", url: "#", src: "images/placeholder.jpg" },
  ];
  
  // Offizielle Sponsoren (Namensliste wie im Screenshot)
  export const officialSponsors = [
    { name: "Stadtwerke Bernau GmbH", url: "https://www.stadtwerke-bernau.de/" },
    { name: "Sparkasse Barnim", url: "https://www.spk-barnim.de/" },
    // { name: "Michels Schraubenquelle GmbH", url: "https://www.michelsschraubenquelle.de/Index.php" },
    // { name: "Schlüsseldienst Nitschke", url: "https://www.schluesseldienst-bernau.de/" },
    // { name: "Mantis Nutrition", url: "#" },
    // { name: "Han Printing", url: "#" },
    // { name: "Golden Lotus Spa", url: "#" },
    // { name: "Thunder Tea", url: "#" },
    // { name: "Jade Telecom", url: "#" },
    // { name: "Blue Crane", url: "#" },
    // { name: "ZenWare", url: "#" },
    // { name: "Silk Road Travel", url: "#" },
  ];
  
  
